module.exports = __webpack_public_path__ + "media/img/home/img_thumb-2-5b9b1f8a7fb24bba1317abbfddc94a3f.png";